/* eslint-disable */
import Accordion from '../components/Accordion';

export default {
	init() {
		Accordion();
	},
	
	finalize() {
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/page-offers.js